/**
 * Returns a promise that resolves after the given number of milliseconds
 * @param milliseconds time to wait for in milliseconds
 */
export function waitForMs(milliseconds: number) {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
}
